import React from "react";
import { useNavigate } from "react-router-dom";
import { calculateAge } from "../../_helper/constant/constant";
import { formatDate } from "../../_helper/utils/utils";

const PrescriptionRow = ({ prescription }) => {
  const navigate = useNavigate();

  return (
    <tr className="border-t hover:bg-gray-100 transition">
      <td className="px-4 py-2">{prescription.id}</td>
      <td className="px-4 py-2">{prescription.patient_id.full_name}</td>
      {/* <td className="px-4 py-2">{prescription.patientId}</td> */}
      <td className="px-4 py-2">{calculateAge(prescription.patient_id.dob)}</td>
      <td className="px-4 py-2">{prescription.patient_id.phone}</td>
      <td className="px-4 py-2">{prescription.patient_id.gender}</td>
      <td className="px-4 py-2">{"Pharmacy"}</td>
      <td className="px-4 py-2">{formatDate(prescription.date)}</td>
      {/* <td className="px-4 py-2">{renderPriorityTag(prescription.priority)}</td> */}
      <td className="px-4 py-2 text-right">
        <button
          onClick={() =>
            navigate(
              `/new/pharmacy/prescription/${prescription.prescriptionNo}`
            )
          }
          className="text-green-600 hover:text-green-800 text-sm font-medium underline"
        >
          View Details →
        </button>
      </td>
    </tr>
  );
};

export default PrescriptionRow;
